const PARAGRAPH_PODCAST = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
   ... on Popular {
      id
      heading
      icon
      type
      uuid
      listing {
        nid
        bodyListing
        summaryListing
        publishedOn
        memberOnly
        title
        pathAlias
        author
        featuredImage {
          alt
          url
          horizontalCardImage
        }
        categories {
          alias
          color
          name
          weight
        }
        ... on Article {
          authors {
            title
            pathAlias
          }
          ctaButtons {
            color
            title
            url
          }
          readDuration
        }
        ... on News {
          ctaButtons {
            color
            title
            url
          }
        }
      }
    }
  }
`;

export default PARAGRAPH_PODCAST;
